import { store } from "./app/store";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import {
  AuthProvider,
  TAuthConfig,
  TRefreshTokenExpiredEvent,
} from "react-oauth2-code-pkce";
import { v4 as uuidv4 } from "uuid";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const authConfig: TAuthConfig = {
  clientId: window.config.OAUTH_CLIENT_ID,
  authorizationEndpoint: `${window.config.API_BASE_URL}/auth/ebay/authorize`,
  tokenEndpoint: `${window.config.API_BASE_URL}/auth/ebay/token`,
  redirectUri: `${window.location.origin}/callback`,
  extraTokenParameters: {
    state: new URL(window.location.href).searchParams.get("state"),
  },
  state: uuidv4(),
  clearURL: false,
  decodeToken: false,
  postLogin: () => {
    window.location.href = "/";
  },
  onRefreshTokenExpire: (event: TRefreshTokenExpiredEvent) =>
    event.logIn(undefined, undefined, "popup"),
};

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider authConfig={authConfig}>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>,
);
